import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UtilService } from '../util.service';
import { VenderApi } from './api-vender';

@Injectable({
  providedIn: 'root',
})
export class VenderService {
  constructor(private util: UtilService, public api: VenderApi, public storage: Storage) {}

  get_balance(data?: any): Promise<any> {
    let endpoint = 'appv2/balance';

    return new Promise(async (resolve, reject) => {
      let params: any = {};

      try {
        const result = await this.api.get(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得點數交易紀錄
  get_coin_txn_log(data?: any): Promise<any> {
    let endpoint = 'appv2/point/show_my_point_history';

    return new Promise(async (resolve, reject) => {
      let params: any = {};

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  private extractData(res) {
    console.log(res);
    let body = res; //httpclient , res已經是json
    console.log(body);
    if (body.returnCode === 'OK') {
      return body;
    } else {
      throw { api_error: true, message: body.message };
    }
  }
}
